/* eslint-disable max-len */
import { AvatarCustom, ReviewRating } from "../../../components";
/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import { capitalizeFirstLetterGeneric, formatDoctorNames, getEventDataForCustomerRating } from "../../../utils/genericUtils";

import { CloseIcon } from "../../../components/Icons";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { fromUnixToShortWeekFormat } from "../../../utils/unix-timestamp";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { useMediaQuery } from "@mui/material";
import { useModal } from "../../../context/ModalContext";
import { userActivityLogger } from "../../../utils/mixpanel";
import { ASSIGNED_BOOKING_TYPE } from "../../../config/params";

const ViewPastAppointmentReview = ()=>{
  const isSmallScreen = useMediaQuery("(max-width: 600px)");
  const { appointmentDetails, setAppointmentDetails } = useAppointmentStore();

  const { closeModal } = useModal();

  const handleCloseModal = () => {
    closeModal();
    setAppointmentDetails(null);
  };


  const { petName, day, month, resources, time } =
  getEventDataForCustomerRating(appointmentDetails);

  useEffect(()=>{
    userActivityLogger(MIXPANEL_EVENTS.VISIT_PAST_REVIEW,
      {
        pet_name: petName || "",
        doctor_name: formatDoctorNames(resources) || "",
        date: `${month} ${day}` || "",
        time_slot: time || "",
      });

    return ()=>{
      setAppointmentDetails(null);
    };
  }, []);

  const bookingDate = appointmentDetails &&
  fromUnixToShortWeekFormat(appointmentDetails.start_at, appointmentDetails.location.timeZone);

  const feedbackMappedData = [
    {
      title: appointmentDetails?.feedback?.[0]?.socQuestion,
      answer: appointmentDetails?.feedback?.[0]?.answer,
      reviewStar: true,
    },
    {
      title: appointmentDetails?.feedback?.[1]?.socQuestion,
      subTitle: appointmentDetails?.feedback?.[1]?.socSubText,
      answer: appointmentDetails?.feedback?.[1]?.answer,
    },
    {
      title: appointmentDetails?.feedback?.[2]?.socQuestion,
      subTitle: appointmentDetails?.feedback?.[2]?.socSubText,
      answer: appointmentDetails?.feedback?.[2]?.answer,
      isFeedbackBox: true,
    },
    {
      title: appointmentDetails?.feedback?.[3]?.socQuestion,
      subTitle: appointmentDetails?.feedback?.[3]?.socSubText,
      answer: appointmentDetails?.feedback?.[3]?.answer,
      isFeedbackBox: true,
    },
  ];

  return (
    <div className="w-full px-1 sm:px-4 py-1 !h-full flex flex-col justify-between overflow-y-auto">
      <div className="flex flex-col gap-3">
        <div className="flex w-full justify-end">
          <CloseIcon
            onClick={handleCloseModal}
            className="text-black cursor-pointer mt-1"
          />
        </div>
        <div className="flex flex-col gap-6 items-center self-stretch flex-1">
          {/* details */}
          <div className="flex flex-col gap-2 w-full">
            <div>
              {appointmentDetails && <div id="avatars" className="float-right xl:pe-[1rem] 2xl:pe-[1.5rem]">
                <AvatarCustom
                  name={appointmentDetails?.pet?.name}
                  width={isSmallScreen ? 60: 80}
                  height={isSmallScreen ? 60: 80}
                  image={appointmentDetails?.pet?.image!}
                  className="border-2 border-white bg-white rounded-full"
                />
              </div>}
              <div id="details" className="flex flex-col items-start gap-1 flex-1">
                <h2 className="text-lg sm:text-2xl font-bold leading-6 text-wrap max-w-[90%]">
                  {capitalizeFirstLetterGeneric(appointmentDetails?.pet.name)}&apos;s Appointment?
                </h2>
                <div className="text-sm sm:text-base leading-5">
                  <p>GoodVets {appointmentDetails?.location.locationName}<span className="mx-1">&#xb7;</span> {bookingDate?.weekday}, {" "}
                    {bookingDate?.month} {bookingDate?.day}</p>
                  <p>at {bookingDate?.time} {
                    appointmentDetails && (appointmentDetails?.appointmentCreateType === ASSIGNED_BOOKING_TYPE.NORMAL_BOOKING) &&
                    appointmentDetails?.resources?.length &&
                    appointmentDetails.resources[0].name &&
                    (formatDoctorNames(appointmentDetails?.resources) !== "") &&
                    <span>with <b>{formatDoctorNames(appointmentDetails?.resources)}</b></span>}</p>
                </div>
              </div>
            </div>
          </div>
          {/* details end */}
          <div className="flex flex-col gap-4 self-stretch items-start">
            {feedbackMappedData.map((feedback, index)=>(
              <div key={index} className="flex flex-col p-4 items-start gap-[10px]
             self-stretch rounded-lg border border-taupe-50 bg-white">
                <div id="title_and_subtitle">
                  <p className="text-sm font-bold leading-4">{feedback.title}</p>
                  {feedback.subTitle && <p className="text-sm leading-5">{feedback.subTitle}</p>}
                </div>
                {feedback.reviewStar ?
                  <ReviewRating readonly iconHeight={48} iconWidth={48} value={+feedback.answer!} />: null
                }
                {feedback.isFeedbackBox ?
                  <div id="feedback-box" className="w-full rounded-lg border border-taupe-50 bg-white p-2">
                    <p className="text-sm leading-5">{feedback.answer}</p>
                  </div>:
                  feedback.reviewStar ? null :
                    <div id="answer" className="text-lg leading-4 font-bold">{feedback.answer}</div>
                }
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewPastAppointmentReview;
